/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import McAnswerParam from './McAnswerParam';
import McMcTranslationParam from './McMcTranslationParam';

/**
 * The McUpdateMcParam model module.
 * @module model/McUpdateMcParam
 * @version 1.0
 */
class McUpdateMcParam {
    /**
     * Constructs a new <code>McUpdateMcParam</code>.
     * @alias module:model/McUpdateMcParam
     */
    constructor() { 
        
        McUpdateMcParam.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>McUpdateMcParam</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/McUpdateMcParam} obj Optional instance to populate.
     * @return {module:model/McUpdateMcParam} The populated <code>McUpdateMcParam</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new McUpdateMcParam();

            if (data.hasOwnProperty('answers')) {
                obj['answers'] = ApiClient.convertToType(data['answers'], [McAnswerParam]);
            }
            if (data.hasOwnProperty('explanation')) {
                obj['explanation'] = ApiClient.convertToType(data['explanation'], 'String');
            }
            if (data.hasOwnProperty('mcId')) {
                obj['mcId'] = ApiClient.convertToType(data['mcId'], 'Number');
            }
            if (data.hasOwnProperty('question')) {
                obj['question'] = ApiClient.convertToType(data['question'], 'String');
            }
            if (data.hasOwnProperty('translation')) {
                obj['translation'] = ApiClient.convertToType(data['translation'], {'String': McMcTranslationParam});
            }
        }
        return obj;
    }


}

/**
 * @member {Array.<module:model/McAnswerParam>} answers
 */
McUpdateMcParam.prototype['answers'] = undefined;

/**
 * @member {String} explanation
 */
McUpdateMcParam.prototype['explanation'] = undefined;

/**
 * @member {Number} mcId
 */
McUpdateMcParam.prototype['mcId'] = undefined;

/**
 * @member {String} question
 */
McUpdateMcParam.prototype['question'] = undefined;

/**
 * @member {Object.<String, module:model/McMcTranslationParam>} translation
 */
McUpdateMcParam.prototype['translation'] = undefined;






export default McUpdateMcParam;

